import { BaseIcon, Icon } from "@dgs/core";
import { FC, HTMLProps, ReactNode } from "react";
import styled from "styled-components";

export const ButtonCardBody = styled.div`
	display: flex;
	flex-direction: column;
	padding: ${(props) => props.theme.spacing(4)};
	gap: ${(props) => props.theme.spacing(2)};
`;

export const ButtonCardIconRow = styled.div`
	display: grid;
	grid-template-columns: max-content 1fr;
	gap: ${(props) => props.theme.spacing(2)};
`;

export const ButtonCardBaseIcon = styled(BaseIcon)`
	width: 24px;
	height: 24px;
`;

export const ButtonCardIcon = styled(Icon)`
	width: 24px;
	height: 24px;
`;

export const ButtonCardWrapper = styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.palette.black};
	background: ${({ theme }) => theme.colors.palette.white};
	border: 1px solid ${({ theme }) => theme.colors.card.background.outline};
	${({ theme }) => theme.borderRadius.large};
	overflow: hidden;

	&[aria-pressed="true"] {
		color: ${({ theme }) => theme.colors.palette.primary.main.contrast};
		background: ${({ theme }) => theme.colors.palette.primary.main.base};
		border-color: transparent;
	}

	&:focus-visible {
		outline: solid 2px ${({ theme }) => theme.colors.palette.primary.main.base};
	}

	a {
		color: inherit;
		text-decoration: none;

		&:hover,
		&:focus-visible {
			text-decoration: underline;
		}
	}
`;

const ButtonCardContainer = styled.div`
	position: relative;
	height: 100%;
`;

const ButtonCardDisabledOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.3);
	${({ theme }) => theme.borderRadius.large};
`;

interface Props extends HTMLProps<HTMLDivElement> {
	children: ReactNode;
	disabled?: boolean;
}

export const ButtonCard: FC<Props> = ({ children, disabled = false, ...htmlProps }) => {
	return (
		<ButtonCardContainer>
			<ButtonCardWrapper {...htmlProps}>{children}</ButtonCardWrapper>
			{disabled && <ButtonCardDisabledOverlay />}
		</ButtonCardContainer>
	);
};
